import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { data } = action.payload;
    const url = config.api.paths.uploadSignature;
    try {
        const res = yield call(http.authorized.post, url, data);
        yield put(actionCreators.postSuccess([res.data]));
    } catch (error) {
        console.error(error);
        logToSentry("On dealer contact post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}
function* deleteReq(action) {
    const { data } = action.payload;
    const url = config.api.paths.deleteDealerContact;
    try {
        const res = yield call(http.authorized.post, url, data);
        if (res?.status === 200) {
            yield put(actionCreators.deleteSuccess(data.id));
        } else {
            yield put(actionCreators.postFailure(res));
        }
    } catch (error) {
        console.error(error);
        logToSentry("On dealer contact delete:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.DEALER_CONTACT_POST_REQUEST, post),
        takeLatest(actionTypes.DEALER_CONTACT_DELETE_REQUEST, deleteReq)
    ]);
}
